import { apiRoutes } from '../../../../constants/apiRoutes.ts';
import { UpcomingAuctionCard } from './components/SaleCards/UpcomingAuctionCard.tsx';
import { AuctionInfiniteList } from './components/AuctionInfiniteList.tsx';
import { SaleStatus, AuctionType } from '../../../auctions/types.ts';
import { SaleTypeFilter } from './components/SaleTypeFilter.tsx';
import { AuctionListQueryParams } from '../../../../constants/apiRoutes/auctionListQueryParams.ts';
import { useState, useMemo } from 'react';
import { faPrint } from '@fortawesome/free-solid-svg-icons';
import { BaseButton } from '@cksoftware/react-base';
import { usePrintUpcomingAuctionsReportPdf } from './hooks/usePrintUpcomingAuctionsReportPdf.ts';

export const UpcomingAuctions = () => {
  const [selectedSaleTypes, setSelectedSaleTypes] = useState<AuctionType[] | undefined>();

  const handleSaleTypeChange = (types?: AuctionType[]) => {
    setSelectedSaleTypes(types);
  };

  const queryParameters: Partial<AuctionListQueryParams> = useMemo(() => {
    return {
      status: SaleStatus.Consigning,
      orderBy: 'SaleDate',
      types: selectedSaleTypes
    };
  }, [selectedSaleTypes]);

  const handlePrintButtonClick = usePrintUpcomingAuctionsReportPdf(queryParameters);

  return (
    <AuctionInfiniteList
      title={'Upcoming Sales and Events'}
      route={apiRoutes.auctions.list}
      queryParameters={queryParameters}
      renderItem={UpcomingAuctionCard}
      emptyListMessage={'No upcoming sales or events'}
      filterComponent={<SaleTypeFilter onFilterChange={handleSaleTypeChange} />}
      printComponent={
        <BaseButton icon={faPrint} onClick={() => handlePrintButtonClick()}>
          PRINT / DISPLAY PDF
        </BaseButton>
      }
    />
  );
};
